export const SERVICES_NAV = [
  { label: "Security Service", to: "/services/security-service" },
  { label: "Housekeeping Service", to: "/services/housekeeping-service" },
  { label: "Event Management", to: "/services/event-management" },
];

export const NAV = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services", children: SERVICES_NAV },
  { label: "Clients", to: "/clients" },
  { label: "Gallery", to: "/gallery" },
  { label: "About Us", to: "/about" },
  { label: "Contact Us", to: "/contact" },
];

export const slug = (to) => (to === "/" ? "home" : to.slice(1).replace(/\//g, "-"));

export const CONTACT = {
  phone: "040-45556423",
  whatsapp: "+91 6006739135",
  mobiles: ["+91 7680909631", "+91 7680009074"],
  email: "sales.s4senterprises.pvt.ltd@gmail.com",
  hours: "Mon-Sat, 9:00-17:00 Hrs",
  address: "Plot no.69, Vivekananda Nagar, Puppalaguda Rd, Narsingi, Hyderabad, Telangana-500075",
};

export const EASE = [0.16, 1, 0.3, 1];
